$('.b-tabs__link').on('click', function () {
  $(this) 
    .closest('.b-tabs')
    .find($('.b-tabs__link'))
    .removeClass('active');
  $(this).addClass('active');
  $(this)
    .closest('.b-tabs')
    .find($('.b-tabs__tab'))
    .removeClass('active');
  $(this)
    .closest('.b-tabs')
    .find($('.b-tabs__tab')[$('.b-tabs__link').index($(this))]) 
    .addClass('active');
});



// WEBPACK FOOTER //
// ./src/js/general/tabs.js